// Services.jsx



import React from 'react';
import { Box, Typography, Grid, Paper, Button } from '@mui/material';
import Header from '../header/Header';
import ServicesStyles from './Services.styles';

const Services = () => {
  return (
    <>
      <Header />

      {/* Hero Section */}
      <Box sx={ServicesStyles.heroSection}>
        <Typography variant="h3" component="h1" sx={ServicesStyles.heroTitle}>
          Remote Property Access
        </Typography>
        <Typography variant="h6" component="p" sx={ServicesStyles.heroSubtitle}>
          Manage and monitor your properties from anywhere with <strong>secure, smart access technology</strong>.
        </Typography>
        <Button variant="contained" sx={ServicesStyles.heroButton}>
          Learn More
        </Button>
      </Box>

      {/* Subscription Overview Section */}
      <Box sx={ServicesStyles.subscriptionSection}>
        <Typography variant="h4" sx={ServicesStyles.sectionTitle}>
          Subscription Details
        </Typography>
        <Typography variant="body1" sx={ServicesStyles.subscriptionText}>
          Subscribe to remote property access using the smart equipment already installed. Get real-time alerts, monitor vacant properties, and give access to tenants or maintenance teams without physical keys.
        </Typography>
        <Grid container spacing={4} sx={{ marginTop: '1rem' }}>
          <Grid item xs={12} md={6}>
            <Paper sx={ServicesStyles.pricingCard}>
              <Typography variant="h5" sx={ServicesStyles.pricingTitle}>
                For Property Managers
              </Typography>
              <Typography variant="h6" sx={ServicesStyles.pricingPrice}>
                $24.95 / month
              </Typography>
              <Typography variant="body2" sx={ServicesStyles.pricingDetails}>
                Covers all properties under management, including vacant property monitoring, real-time alerts, and unlimited rental showings.
              </Typography>
            </Paper>
          </Grid>
          {/* <Grid item xs={12} md={6}>
            <Paper sx={ServicesStyles.pricingCard}>
              <Typography variant="h5" sx={ServicesStyles.pricingTitle}>
                For Tenants
              </Typography>
              <Typography variant="h6" sx={ServicesStyles.pricingPrice}>
                $12.75/ month per property
              </Typography>
              <Typography variant="body2" sx={ServicesStyles.pricingDetails}>
                Enjoy <strong>seamless smart home features</strong> with no upfront equipment costs.
              </Typography>
            </Paper>
          </Grid> */}
        </Grid>
      </Box>

      {/* Key Features Section */}
      <Box sx={ServicesStyles.featuresSection}>
        <Typography variant="h4" sx={ServicesStyles.sectionTitle}>
          Key Features
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Paper sx={ServicesStyles.featureCard}>
              <Typography variant="h5" sx={ServicesStyles.featureTitle}>
                Smart Access Control
              </Typography>
              <Typography variant="body1" sx={ServicesStyles.featureText}>
                Use smart technology like Ring Doorbell to securely manage property access remotely for tenants and maintenance teams.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper sx={ServicesStyles.featureCard}>
              <Typography variant="h5" sx={ServicesStyles.featureTitle}>
                Real-Time Monitoring
              </Typography>
              <Typography variant="body1" sx={ServicesStyles.featureText}>
                Receive instant alerts and monitor vacant properties from anywhere, enhancing security and oversight.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper sx={ServicesStyles.featureCard}>
              <Typography variant="h5" sx={ServicesStyles.featureTitle}>
                Automated Showings
              </Typography>
              <Typography variant="body1" sx={ServicesStyles.featureText}>
                Streamline rental showings with remote access, making it easy for prospective tenants to view properties.
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Box>

      {/* Additional Benefits Section */}
      <Box sx={ServicesStyles.benefitsSection}>
        <Typography variant="h4" sx={ServicesStyles.sectionTitle}>
          Why Choose Us
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Paper sx={ServicesStyles.benefitCard}>
              <Typography variant="h6" sx={ServicesStyles.benefitTitle}>
                24/7 Support
              </Typography>
              <Typography variant="body1" sx={ServicesStyles.benefitText}>
                Round-the-clock assistance to ensure your properties are always managed smoothly.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper sx={ServicesStyles.benefitCard}>
              <Typography variant="h6" sx={ServicesStyles.benefitTitle}>
                Customizable Options
              </Typography>
              <Typography variant="body1" sx={ServicesStyles.benefitText}>
                Tailor access and showing settings to fit your specific management needs.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper sx={ServicesStyles.benefitCard}>
              <Typography variant="h6" sx={ServicesStyles.benefitTitle}>
                Actionable Insights
              </Typography>
              <Typography variant="body1" sx={ServicesStyles.benefitText}>
                Leverage data from access activities to optimize your property management strategy.
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Services;